import { render, staticRenderFns } from "./GeoLocation.vue?vue&type=template&id=35fbb13b&scoped=true&"
import script from "./GeoLocation.vue?vue&type=script&lang=ts&"
export * from "./GeoLocation.vue?vue&type=script&lang=ts&"
import style0 from "./GeoLocation.vue?vue&type=style&index=0&id=35fbb13b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbb13b",
  null
  
)

export default component.exports